import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/common/header/Header";
import { AnimatePresence } from "framer-motion";

const Homelayout = () => {
  return (
    <AnimatePresence mode="wait">
      <div className="w-screen h-auto flex flex-col bg-primary">
        <Header />
        <main className="mt-[5.5rem] px-4 md:px-16 py-4 w-full">
          <Outlet />
        </main>
      </div>
    </AnimatePresence>
  );
};

export default Homelayout;
